import { Application } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"

import DisableController from "../controllers/support/disable_controller"
import PasswordVisibility from "stimulus-password-visibility"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application
Stimulus.register("support--disable", DisableController)
Stimulus.register('password-visibility', PasswordVisibility)

export { application }
